module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h1', [_vm._v("Violet")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-a"
  }, [_vm._v("A")]), _vm._v("S I WALKED TO THE")]), _vm._v(" sun-drenched courtyard for my morning martial arts training, I saw my trainer, Lucinda, in the distance, pacing.  Surrounded by vine covered stone walls that kept the area cool in the summer and protected us from the cold winds in the winter, she walked to one end of the enclosure, looked up then walked back toward the portion covered with a leather tarp.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With her black hair pulled back tightly into a neat bun and her hands clasped patiently behind her back, she stopped, tilted her face up to the sun and resumed pacing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew that expression on her face.  She was upset by my tardiness.  As kind and as understanding as she could be, she did not accept any show of disrespect.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m coming, Lucinda,” I called out before she grew too impatient and left.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked up to me, the sun in her face forcing her to squint.  Small and compact, she was all muscle, but with an elegant grace that tricked her opponent into thinking she was an easy target.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nothing could be further from the truth.  She was a master, and beyond the techniques she’d shown me over the years, she always emphasized the mental aspect of any combat.  Mental strategy was important.  Playing with the opponent’s confidence, dismantling it, was just as important as physically tearing him down.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m sorry I’m late,” I said as I came up to her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s certainly is nice to have the luxury of sleeping in every once in a while,” she said with tight lips.  She put her delicate looking hands on her hips.  “Of course, I wouldn’t really know because I am out here well before dawn every morning.  Staying in bed until the sun is high is something I have not experienced since I was a small child.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I really am sorry.  I know how you feel about tardiness.  I...”  I said, trying to convey my profound regret.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lucinda held up her hand, silencing me.  “Don’t give me your excuses.  Your desire to stay in bed tells me that my time is not valuable to you.  Despite that, I am here now.  Let’s not waste any more time and just get to business.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted to say something but knew that it was no use.  Instead I dutifully nodded, set my towel down on the nearby stone bench and kicked my boots off.  With the fine cool sand under my bare feet, I joined her in the center of the square.  I put my hands flat against each other in a show of respect and bowed.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("For a quick fifteen minutes, we went through a variety of stretching exercises.  We reached for the sun, from the tip of our toes to our fingertips, then we swept the ground with the palms of our hands.  We lunged forward, arched back and reached for the sun again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Once limbered up, we move on to light hand to hand combat with gentle and slow moves meant to simulate battle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then we started the heavier work-out.  For the next hour we did a number of exercises that got my heartrate up and had me breathing hard.  Sweat ran down my back, between my breasts and into my eyes.  Then we got into various motions, a kick, a turn, a swipe of the hand.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I tried to back away from Lucinda’s strike as she kicked at me, but she landed a blow on the side of my head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wake up, sleepy girl,” Lucinda said, quickly landing another blow of her bare foot to my backside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I winced but refused to let out just how much her blow hurt.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She spun around and landed the heel of her foot into my belly.  I doubled over and staggered back.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Wakey, wakey, precious one,” she taunted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Holding my gut, I looked at her.  A part of me wanted to beg for mercy, but I knew better.  Her idea of mercy would be to come at me even harder.  Coddling was not in her vocabulary.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What’s wrong with you?” Lucinda said when she easily caught my cheek with the back of her hand.  “You’re all wishy washy this morning.  No matter what, you don’t wake up... really wake up.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I shook the fatigue from my head and nodded, signaling that I was ready to try again.  When she made no move, I said, “Come now.  I’m ready.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her thirty-five year old tight little body twisted, turned, then jumped in the air, her toe clipping my ear.  Coming to a dead stop, she stood, feet planted firmly apart with her frustrated fists on her hips.  Defiant and disappointed, she stared at me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“First you’re late,” she shot out.  “Now you don’t fight like I taught you.  Are you mocking me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, Lucinda.  Of course not.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then what is it?”  She looked at me, daring me to make a weak excuse.  “Tell me now.  Or I will beat it out of you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew that she would, too.  I looked at her, wanting to tell her about my dream.  I wanted to share the dream with someone.  I needed to share it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But then again, a part of me wasn’t ready to talk about it.  I was still shaken by the images, by the sensation of that arrow.  It all seemed so real, so disturbingly real.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I’d died.  How could I tell her that without making her laugh?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” Lucinda said, gesturing to the stone bench.  Her shoulders slacked and her stance softened.  “Let’s sit down.  You tell me what’s wrong.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Averting her eyes, I looked to the ground.  I looked at the sand beneath my feet, then looked to the surrounding fine sand that had been tediously raked so as to depict the rays of the sun over the horizon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was a soothing task that she had taught me, one that was calming and quite pleasant.  Every morning, before our practice session, I took the wooden rake and moved the sand to create a new pattern.  Sometimes it was simple geometric shapes, and at other times more detailed drawings.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But today, the sand was the same as the day before, perhaps just a little softened by the overnight wind.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Come, Violet,” Lucinda said.  “There is clearly no point in working with you today.  Your head is not here.  Your head is somewhere else.  I need your head here, or else it’s no use.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I went to her and sat down, my eyes still cast to the raked sand.  “I know.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You know you are wasting my time?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nodding.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You better tell Lucinda all about it, or else we’ll never get anything done today.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I had a dream last night,” I said softly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, I did too,” Lucinda said sarcastically.  “So, what else is new?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked at her with all the fear that dream had left me with, and her sarcastic grin disappeared.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, honey,” she said more tenderly.  “You had a nightmare?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded as I clasped my hands over my lap and stared blindly at my fingertips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I died,” I murmured softly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She was silent for a long moment.  “How?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Prince Axel,” I said.  Taking in a deep breath, I looked at her.  “He was angry and wanted revenge.  I went to him, to calm him and tell him that I loved him.  He was there... in front of me, so real.  It was all so real.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Then what happened.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I shrugged as I brought my troubled gaze back to my hands.  “I don’t know where it came from... who shot it, but I felt an arrow go through me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She took my hand and I reluctantly looked up to her with tears in my eyes.  I hated crying in front of her.  I hated crying.  I was not the type easily given to crying.  I was strong.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Wasn’t I?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It felt so real,” I said.  “It hurt.  It burned.  And as my blood soaked my clothing and then pooled on the ground, I grew cold.”  I looked at her.  “I was so cold, Lucinda.  I shivered until I was weak, until I was nauseous.  Then everything faded to nothing.  Just nothing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But you are alive and well now,” Lucinda said very matter-of-factly.  “Why are you so upset?  Surely this isn’t the first time you have a nightmare.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, it’s not the first time, but it’s never felt like this.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You mean real?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes.  Absolutely.  It all felt so real.  Too real.”  I looked into her eyes.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A small, knowing grin came to her lips.  “There’s more to it than just that, isn’t there?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked up to the sky, blinking back the tears.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know it sounds absurd, but I think it might be a sign of things to come.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lucinda patted my knee.  “Well, you are the Kingmaker’s daughter,” she said.  “There is the strong possibility that you’ve inherited your father’s gifts.  Then again, it may simply be that you are too concerned about Prince Axel.  Many times our dreams are reflections of our emotions.  They are mirrors, at times distorted mirrors, that show us all our joys and sorrows.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded and forced a smile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You have to be careful, dear,” Lucinda said.  “You must learn to discern between a mere dream and a true vision of what is to come.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("From where we sat, we had a view of the window to my bedroom up on the second floor.  Beautiful and delicate vines climbed up the wall and surrounded my window, framing it with small white and pink flowers amidst the dark green foliage.  I stared at the glass of my window that reflected the bright blue sky dotted with a scattering of pure white clouds.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was a beautiful day, one that promised to be warm with a gentle breeze.  Yet, I felt so awful... suddenly so vulnerable.  A dark and rainy day would have suited my mood better.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Despite being so troubled by your dream,” Lucinda said, “you had a very good training today.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I chuckled.  “You hit me three times.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lucinda laughed.  “Yes.  I did.  But considering how you are feeling...  Well, I will try to be understanding.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I knew what she meant.  Forever she had been telling me to keep my emotions separate from combat.  Whether it be sadness or anger, bringing the emotions to battle was rarely effective.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll forgive you if you want to leave a little early.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked at her with surprise.  I knew her work ethic and knew that finishing our training session early went against that ethic.  “Promise you won’t tell Father,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I won’t tell him, if you are here an hour early tomorrow morning to make up for it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stood.  “You drive a hard bargain, Lucinda.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” she said with a smile.  “And that’s what you love about me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I grinned and put an affectionate hand to her shoulder.  “Thank you,” I said.  “Thank you for listening.  I needed to get that out of my system.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Any time.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I left her and meandered around the grounds as I tried to clear my head.  The mood of the dream stayed with me, refusing to be shrugged off.  I soon found myself in one of the many gardens around the castle; the rose garden with its pretty statues of children.  One plucked a rose, while another child chased a dog.  Yet another one sat peacefully among the rose bushes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With the scent of the delicate pink rose in my nostrils, I slowed down and fingered the soft petals.  A couple of white doves pecked at the ground nearby.  Looking at them, I suddenly envied them.  They had an easy love relationship.  They just went around, pecking the ground together.  Then they would fly off together.  Did they argue about which way to go?  Did they negotiate when they should take flight? They no doubt shared the same nest, and tomorrow they would spend the day together again.  Was that all filled with anxiety and apprehension or was it really as simple as it seemed?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So simple.  No jealousy.  No complicated decisions.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I walked on and entered the shade of the forest of tall oaks that filled the north eastern corner of the castle grounds.  Squirrels chasing one another crossed the small pebble path in front of me and a deer grazed quietly in the distance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As usual, I found soothing comfort in the natural surroundings.  The numerous animals that shared the castle grounds had often been responsible for making me smile when I was down or upset.  They lifted my mood without even trying... without even caring about how I felt.  Just by being.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took the path that looped around and led back to the vegetable garden behind the kitchen.  Spotting a juicy red tomato on a weighted plant, I plucked it and took a big bite as I headed into the kitchen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you eating, child?” Rosie said.  She looked at me with big, scolding eyes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Taking another juicy bite, I smiled.  Rosie was always checking out everything I put in my mouth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s just a tomato,” I said, holding it up for her to see.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You’ll ruin your appetite,” Rosie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hopped up onto the counter and took another bite, careful to not let the juices drip everywhere.  “What are you fixing?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rosie looked at her team of efficient and hard-working cooks.  “Stuffed goose, leg of lamb, roast pork, sweet carrots, seasoned snow peas, yams, pound cake, mashed potatoes.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you expecting the whole village for dinner?” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rosie looked at me and pursed her lips.  “You might put it that way.  You know darn well who is coming to the banquet tonight.  Every king and queen from all surrounding kingdoms.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With my mouth filled with tomato juice, I stared at her.  “Oh, my God.  The banquet.  The Choosing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I’d been so caught up in the feelings my dream had left me that I’d come to believe the Choosing had been postponed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But the nightmare was over, and I was right back to reality.  The Choosing would happen tonight.  And as neutral ground to all kingdoms, it would happen right here.  A long time ago, my father, Kingmaker Killian Kingsbury, had established it as the central place for negotiations, treaties and peace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tonight.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If you don’t mind, Violet, I could sure use a hand,” Rosie said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, of course, Rosie.”  I mentally went through all the things I had to do to be ready for the evening’s affair.  Bathing and washing my hair.  Putting my hair up.  My dress.  If all went well, I should have more than enough time to help Rosie.  “What can I do to help?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was down in the wine cellar earlier this morning.  Darn it, that place is so big.  I almost lost my way in that labyrinth of Bordeaux, Merlot, Pinot Noir and Chianti.  But, with all that, there is not a drop of Chardonnay.  And you know how Queen Penelope is about her Chardonnay.  Would you mind terribly running into town to get some?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hesitated.  Going into town was a little more than I had expected.  I suddenly felt like I had so much to do in so little time.  “Sure,” I finally said.  “Anything else?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, now that you ask,” Rosie said with a smile.  “We have plenty of cheddar, but we have no brie or provolone.  Could you bring back some.  And while you’re at it, I really could use five more apples, three peaches and a small cantaloupe.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded and took a final look at the large kitchen bustling with culinary activity.  “I’ll be back soon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I grabbed a handful of grapes and headed out through the dining area, also alive with much activity.  The formal dining room had already been scrubbed and cleaned, and a small army of workers were bringing in large potted trees, flowering shrubs and delicate flowers.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And as I passed the grand ballroom, the preparations for the night ahead continued, with workers draping gold, silver and copper silks from each corner of the vast room to the center.  Others worked tediously on a garland of ivy and purple roses that would later be draped over the arches.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Outside, more workers milled around tidying up the main entrance to the castle, trimming hedges, cutting dead branches and sweeping fallen leaves from the long path that led up to the castle moat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Good morning, Miss Violet,” a worker said as I passed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded and smiled in return.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I hear we are to choose a new king,” another said as he took a few paces alongside me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Again, I nodded and smiled.  I knew better than to discuss these matters with anyone.  Many were curious and eager to learn of the new king, but it wasn’t my place to comment.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Besides, there wasn’t much I could say.  Father had refused to tell me who had been chosen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0